export default "/images/vendor/flag-icon-css/flags/1x1/tm.svg?442986488503d5356e8026045953e0d6";